import React, {useCallback} from 'react';
import {formatEventURLDate, useTimeFormatter} from '../../../../data/hooks/datetimeHooks';
import {useEvent} from '../../../../data/hooks/eventHooks';
import {useI18n} from '../../../../data/hooks/i18nHooks';
import {useMeetings} from '../../../../data/hooks/meeting/useMeetings';
import {useForceUpdate} from '../../../../misc/hooks';
import ExternalMeetingLinkButton from '../../../elements/Button/ExternalMeetingLinkButton';
import Link from '../../../elements/Link';
import UserName from '../../../elements/UserName';
import Icon from '../../../elements/icons/Icon';
import UserAvatar from '../../../elements/icons/UserAvatar';
import SidePanelDialog from '../../common/SidePanelDialog/SidePanelDialog';
import styles from './ActiveMeetingWarningDialog.module.scss';
import { confirmedStartingMeetingFilter } from './confirmedStartingMeetingFilter';

const CLOSED_DIALOGS = [];

const ActiveMeetingWarningDialog = props => {
    const {eventId} = props,
        event = useEvent(eventId),
        i18n = useI18n(),
        meeting = useMeetings(eventId, {
            count: 1,
            filter: confirmedStartingMeetingFilter,
        })[0],
        formatTime = useTimeFormatter(),
        forceUpdate = useForceUpdate();

    const handleCloseDialog = useCallback(() => {
        CLOSED_DIALOGS.push(meeting.id);
        forceUpdate();
    }, [meeting]);

    if (!meeting) return null;
    if (CLOSED_DIALOGS.includes(meeting.id)) return null;

    return (
        <SidePanelDialog className={styles.ActiveMeetingWarningDialog} onClose={handleCloseDialog}>
            <Link href={['/events', event.id, 'meetings', formatEventURLDate(event, meeting.start_local), meeting.id].join('/')}>
                <div className="description">
                    <h2>
                        {formatTime(meeting.start_local)} {meeting.name ? meeting.name : i18n['title.notification-alarm']}
                    </h2>
                    <div className={styles.invitees}>
                        {meeting.invited.map((invited, i) => {
                            const {user} = invited;
                            return (
                                <div key={i}>
                                    <UserAvatar className="" user={user} />
                                    <UserName user={user} />
                                </div>
                            );
                        })}
                    </div>
                    {meeting.location && !meeting.virtualroom_url ? (
                        <p className="location marginTop">
                            <Icon src="/img/location.png" color="#787878" size={14} />
                            {meeting.location.name}
                        </p>
                    ) : null}
                </div>
            </Link>
            <ExternalMeetingLinkButton
                {...meeting}
                eventId={event.id}
                meetingId={meeting.id}
                style={{
                    backgroundColor: event.settings.primary_color,
                    fontWeight: 'bold',
                    minWidth: '180px',
                }}
                onClick={handleCloseDialog}
            />
        </SidePanelDialog>
    );
};

export default ActiveMeetingWarningDialog;
